import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';

import { cn } from '../../lib/utils';

const Separator = React.forwardRef(
  (
    {
      className,
      orientation = 'horizontal',
      decorative = true,
      variant = 'default',
      imageSrc,
      ...props
    },
    ref
  ) => (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={cn(
        'shrink-0',
        orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]',
        variant === 'default' && 'bg-border',
        variant === 'image' && 'bg-center bg-no-repeat bg-cover',
        variant === 'dotted' && 'border-2 border-dotted border-border',
        variant === 'dotted' && orientation === 'horizontal' && 'border-b',
        variant === 'dotted' && orientation === 'vertical' && 'border-r',
        className
      )}
      style={variant === 'image' ? { backgroundImage: `url(${imageSrc})` } : undefined}
      {...props}
    />
  )
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
